import React from 'react';
import { Button } from './ui/Button';
import { Download, ShieldCheck, Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-[#1E3A5F] text-white text-center" data-id="element-147">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-148">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-149">
          Tomá la decisión ahora.
        </h2>

        <div className="space-y-6 text-xl text-blue-100 mb-12 leading-relaxed" data-id="element-150">
          <p data-id="element-151">Pensá en el próximo domingo a la noche.</p>
          <p data-id="element-152">
            Podés seguir buscando material hasta la medianoche, durmiendo tarde
            y arrancando el lunes agotada.
          </p>
          <p className="font-bold text-white" data-id="element-153">
            O podés estar descansada porque ya sabés que el lunes está todo
            listo.
          </p>

          <div className="bg-white/10 p-6 rounded-2xl mt-8" data-id="element-154">
            <p className="mb-2" data-id="element-155">
              La diferencia entre esos dos domingos vale{' '}
              <span className="text-[#F59E0B] font-bold" data-id="element-156">$19.990 ARS.</span>
            </p>
            <p className="text-lg italic" data-id="element-157">
              Menos que una cena afuera. Menos que un par de zapatillas.{' '}
              <span className="font-bold text-white not-italic" data-id="element-158">
                Un año entero de clases de Lengua resuelto.
              </span>
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center" data-id="element-159">
          <Button href="Link de tu checkout" variant="primary" size="xl" className="w-full md:w-auto shadow-[0_0_30px_rgba(22,163,74,0.5)] mb-8" data-id="element-160">
            👉 Quiero mis lecturas →
          </Button>

          <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base font-medium text-blue-200" data-id="element-161">
            <span className="flex items-center" data-id="element-162">
              <Download className="w-4 h-4 mr-2" data-id="element-163" /> ✅ Descarga inmediata
            </span>
            <span className="flex items-center" data-id="element-164">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-165" /> ✅ Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-166">
              <Lock className="w-4 h-4 mr-2" data-id="element-167" /> ✅ Pago seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}